import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useConsignmentsList() {
  // Use toast
  const toast = useToast()

  const refConsignmenttListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'customer_name', label: 'Müşteri', sortable: true },

    { key: 'return_date', label: 'Geri Alınacağı Tarih', sortable: true },

    { key: 'user', label: 'İşlem Yapılan', sortable: true },
    { key: 'representative_user', label: 'Firma Temsilci', sortable: true },
    { key: 'products', label: 'Ürünler', sortable: true },
    { key: 'description', label: 'Açıklama', sortable: true },
    { key: 'address', label: 'Adres', sortable: true },
    { key: 'return_completion_date', label: 'Durum', sortable: true },
    { key: 'status', label: 'Sevk Durumu', sortable: true },
    { key: 'actions', label: '' },
  ]
  const perPage = ref(10)
  const totalConsignments = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const roleFilter = ref(null)
  const planFilter = ref(null)
  const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refConsignmenttListTable.value ? refConsignmenttListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalConsignments.value,
    }
  })

  const refetchData = () => {
    refConsignmenttListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, roleFilter, planFilter, statusFilter], () => {
    refetchData()
  })

  const fetchConsignments = (ctx, callback) => {
    store
      .dispatch('app-consignment/fetchConsignments', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        role: roleFilter.value,
        plan: planFilter.value,
        status: statusFilter.value,
      })
      .then(response => {
        const { data } = response.data
        const { total } = response.data.meta

        callback(data)
        totalConsignments.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching consignment list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*
  return {
    fetchConsignments,
    tableColumns,
    perPage,
    currentPage,
    totalConsignments,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refConsignmenttListTable,

    refetchData,

    // Extra Filters
    roleFilter,
    planFilter,
    statusFilter,
  }
}
